function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Potential Knows No <span className="highlight">Zip Code</span>
          </h1>
          <p className="hero-subtitle">
            From classrooms with crumbling walls in the Himalayas to underfunded schools in Dallas—brilliant
            minds are limited only by access to resources. We're changing that, one student at a time.
          </p>
          <div className="hero-buttons">
            <a href="#donate" className="btn btn-primary btn-large">
              <i className="fas fa-heart"></i> Give Students a Chance
            </a>
            <a href="#story" className="btn btn-secondary btn-large">
              <i className="fas fa-book-open"></i> See the Reality
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">500+</div>
              <div className="stat-label">Students Waiting for Resources</div>
            </div>
            <div className="stat">
              <div className="stat-number">0</div>
              <div className="stat-label">Science Labs in Rural Nepal Schools</div>
            </div>
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Impact - Every Dollar to Students</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
